var _rect, _path, _circle, _circle2, _circle3, _rect2, _rect3, _rect4, _rect5, _rect6, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffcanvas = function SvgOffcanvas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 42,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 42,
    fill: "#EAEDF1",
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M0 3a3 3 0 0 1 3-3h48a3 3 0 0 1 3 3v3H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 0.5,
    fill: "#EAEDF1",
    stroke: "#EAEDF1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 3,
    r: 0.5,
    fill: "#EAEDF1",
    stroke: "#EAEDF1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 3,
    r: 0.5,
    fill: "#EAEDF1",
    stroke: "#EAEDF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 30,
    x: 27,
    y: 9,
    fill: "#666",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 3,
    x: 29,
    y: 32,
    fill: "#EAEDF1",
    rx: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 31,
    y: 18,
    fill: "#EAEDF1",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    x: 29,
    y: 22,
    fill: "#EAEDF1",
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 43,
    y: 32,
    fill: "#EAEDF1",
    rx: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 12,
    r: 1,
    fill: "#EAEDF1"
  })));
};
export { SvgOffcanvas as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTQiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA1NCA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjU0IiBoZWlnaHQ9IjQyIiByeD0iMyIgZmlsbD0iI0VBRURGMSI+PC9yZWN0Pgo8cGF0aCBkPSJNMCAzQzAgMS4zNDMxNSAxLjM0MzE1IDAgMyAwSDUxQzUyLjY1NjkgMCA1NCAxLjM0MzE1IDU0IDNWNkgwVjNaIiBmaWxsPSIjNjY2NjY2Ij48L3BhdGg+CjxjaXJjbGUgY3g9IjMiIGN5PSIzIiByPSIwLjUiIGZpbGw9IiNFQUVERjEiIHN0cm9rZT0iI0VBRURGMSI+PC9jaXJjbGU+CjxjaXJjbGUgY3g9IjYiIGN5PSIzIiByPSIwLjUiIGZpbGw9IiNFQUVERjEiIHN0cm9rZT0iI0VBRURGMSI+PC9jaXJjbGU+CjxjaXJjbGUgY3g9IjkiIGN5PSIzIiByPSIwLjUiIGZpbGw9IiNFQUVERjEiIHN0cm9rZT0iI0VBRURGMSI+PC9jaXJjbGU+CjxyZWN0IHg9IjI3IiB5PSI5IiB3aWR0aD0iMjQiIGhlaWdodD0iMzAiIHJ4PSIyIiBmaWxsPSIjNjY2NjY2Ij48L3JlY3Q+CjxyZWN0IHg9IjI5IiB5PSIzMiIgd2lkdGg9IjEyIiBoZWlnaHQ9IjMiIHJ4PSIxLjUiIGZpbGw9IiNFQUVERjEiPjwvcmVjdD4KPHJlY3QgeD0iMzEiIHk9IjE4IiB3aWR0aD0iMTYiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiNFQUVERjEiPjwvcmVjdD4KPHJlY3QgeD0iMjkiIHk9IjIyIiB3aWR0aD0iMjAiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiNFQUVERjEiPjwvcmVjdD4KPHJlY3QgeD0iNDMiIHk9IjMyIiB3aWR0aD0iNiIgaGVpZ2h0PSIzIiByeD0iMS41IiBmaWxsPSIjRUFFREYxIj48L3JlY3Q+CjxjaXJjbGUgY3g9IjQ4IiBjeT0iMTIiIHI9IjEiIGZpbGw9IiNFQUVERjEiPjwvY2lyY2xlPgo8L3N2Zz4=";